import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles, HandCoins, Users } from 'lucide-react';

import { Spinner } from '@/components/ui/spinner';
import { useAuthStore } from '@/stores/auth-store';
import { useChurchStore } from '@/stores/church-store';

import { LandingBenefitsSection } from './landing-benefits-section';
import { LandingMarketingShell } from './landing-shared';
import './landing.css';

export const LandingPage = () => {
  const { t } = useTranslation('landing');
  const status = useAuthStore((state) => state.status);
  const restore = useAuthStore((state) => state.restore);
  const churchStatus = useChurchStore((state) => state.status);
  const restoreChurch = useChurchStore((state) => state.restore);
  const signedIn = status === 'authenticated';

  useEffect(() => {
    if (status === 'unknown') void restore();
  }, [status, restore]);

  useEffect(() => {
    if (signedIn && churchStatus === 'unknown') void restoreChurch();
  }, [signedIn, churchStatus, restoreChurch]);

  if (status === 'unknown') {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-surface-sunken">
        <Spinner className="size-6 text-brand" />
      </div>
    );
  }

  return (
    <LandingMarketingShell signedIn={signedIn}>
      <main className="text-on-brand">
        <LandingBenefitsSection />

        <section className="landing-trust-bar" aria-label={t('trust.aria')}>
          <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-4 px-4 py-5 text-center sm:flex-row sm:gap-8 sm:px-6 lg:px-8">
            <p className="flex items-center gap-2 text-body-sm font-medium text-on-brand">
              <Users className="size-4 shrink-0 text-on-brand" aria-hidden />
              {t('trust.names')}
            </p>
            <p className="flex items-center gap-2 text-body-sm font-medium text-on-brand">
              <HandCoins className="size-4 shrink-0 text-on-brand" aria-hidden />
              {t('trust.giving')}
            </p>
            <p className="flex items-center gap-2 text-body-sm font-medium text-on-brand">
              <Sparkles className="size-4 shrink-0 text-on-brand" aria-hidden />
              {t('trust.reach')}
            </p>
          </div>
        </section>
      </main>
    </LandingMarketingShell>
  );
};
